import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';
import { Attachment } from './attachment';

@JsonObject('LearningAttachment')
export class LearningAttachment extends Entity {
  @JsonProperty('learningId', String)
  public learningId?: string = undefined;
  @JsonProperty('attachment', [Attachment])
  public attachments?: [Attachment] = undefined;
}
